export function goBack() {
    return {
        type: "GO_BACK"
    };
}
// eslint-disable-next-line no-redeclare
export function navigate() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (typeof args[0] === "string") {
        return {
            type: "NAVIGATE",
            payload: {
                name: args[0],
                params: args[1]
            }
        };
    } else {
        var payload = args[0] || {};
        if (!payload.hasOwnProperty("key") && !payload.hasOwnProperty("name")) {
            throw new Error("You need to specify name or key when calling navigate with an object as the argument. See https://reactnavigation.org/docs/navigation-actions#navigate for usage.");
        }
        return {
            type: "NAVIGATE",
            payload: payload
        };
    }
}
export function reset(state) {
    return {
        type: "RESET",
        payload: state
    };
}
export function setParams(params) {
    return {
        type: "SET_PARAMS",
        payload: {
            params: params
        }
    };
}
